// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__2Kt5x","noBorder":"divider_noBorder__dO8C8"};